export const SIGIN_NEXT_ROUTE = 'SIGIN_NEXT_ROUTE'
export const SHIPPING_NEXT_ROUTE = 'SHIPPING_NEXT_ROUTE' 